export default __webpack_public_path__ + "static/SRUS YT90 - Product Specifications & Technical Data-b110eef01d1496baa4ef4f662ef7707a.pdf";